module.exports = __webpack_public_path__ + "assets/img/img312.84414828.png";